import { DNA } from '../visual-language'

export function keyboardStyles() {
  return {
    display: 'inline-block',
    height: '28px',
    margin: '0 0.2rem 2px',
    padding: '0 0.4rem',
    backgroundColor: DNA.tokens.color.background,
    boxShadow: `0 0 0 1px ${DNA.tokens.color.grey[400]}, 0 2px 0 0 ${DNA.tokens.color.background}, 0 2px 0 1px ${DNA.tokens.color.grey[500]}`,
    fontFamily: DNA.tokens.font.family.mono,
    fontSize: '12px',
    lineHeight: '28px',
    borderRadius: DNA.tokens.alias.dimension.borderRadius.default,
    color: DNA.tokens.color.grey[600],
    textAlign: 'center',
    minWidth: DNA.tokens.dimension.size[800],
    userSelect: 'none',
  }
}
